import { reportStyles } from './report-styles';

/**
 * @param args.config - merged config + params
 * @param args.doc - jsPdfDoc
 * @param args.data - data.table
 * @param args.resources - { centers: [{...}] }
 */
export function reportHeader(args) {
  const { config, doc, pageNumber, $date } = args;

  let str, x, y;
  const pageWidth = doc.internal.pageSize.width;

  doc.setFont(doc.getFont().fontName, 'normal');
  doc.setTextColor(reportStyles.header.textColor);

  /**
   * Report Name
   */
  // x = data.settings.margin.left; y = 40;
  x = reportStyles.pageMargins[3]; y = 40;
  doc.setFontSize(14);
  str = config.reportName.toUpperCase();
  doc.text(str, x, y); x += doc.getTextWidth(str) + 3;

  /**
   * Report Period
   */
  if (config.date) {
    doc.setFontSize(7);
    // if (config.date) str += ' ' + 'FROM' + ':';
    str = 'for period';
    doc.text(str, x, y); x += doc.getTextWidth(str) + 3;

    doc.setFontSize(9);
    // str = config.date;
    str = $date.transform(config.date, 'MMM y');
    doc.text(str, x, y); x += doc.getTextWidth(str) + 3;
  }

  /**
   * Page
   */
  // x = pageWidth - reportStyles.pageMargins[1];
  // doc.setFontSize(9);
  // str = '' + pageNumber;
  // x -= doc.getTextWidth(str); doc.text(str, x, y);
  // doc.setFontSize(7);
  // str = 'page:';
  // x -= doc.getTextWidth(str + ' '); doc.text(str, x, y - 0.6);

  /**
   * Report Date
   */
  x = pageWidth - reportStyles.pageMargins[1];
  doc.setFontSize(9);
  str = $date.transform(new Date());
  x -= doc.getTextWidth(str); doc.text(str, x, y);
  doc.setFontSize(7);
  str = 'report date:';
  x -= doc.getTextWidth(str + ' '); doc.text(str, x, y - 0.6);
}
